// Libraries
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

// Assets
import { pieLegends } from '../../utils/constants/commonValues';

// Components
import { ChartNoData, Charts } from '../';
import StatusTable from './StatusTable';

// Styles
import './successCard.scss';

/**
 * SuccessCard Component
 *
 * @param {Object} data - React component
 * @param {string} customClass - React className
 */

const getCx = node => {
    if (node && node.clientWidth) {
        return node.clientWidth / 2;
    }
    return 200;
};

const getCy = node => {
    if (node && node.clientHeight) {
        return node.clientHeight / 2;
    }
    return 110;
};

const SuccessCard = ({ customClass, tabData }) => {
    const columns = React.useMemo(
        () => [
            { header: 'Payment Methods', accessor: 'aggregator' },
            {
                header: 'Transaction Count',
                accessor: 'TRANSACTION_COUNT',
            },
            { header: 'Success Rate', accessor: 'SUCCESS_RATE' },
        ],
        []
    );

    const inputEl = useRef(null);
    return (
        <div className="success-card">
            {isEmpty(tabData) ? (
                <ChartNoData title="No data available" />
            ) : (
                <>
                    <div className="card-table">
                        <StatusTable
                            customClass="custom-table"
                            columns={columns}
                            data={tabData}
                        />
                    </div>
                    <div className="card-chart" ref={inputEl}>
                        <Charts
                            type="pie"
                            data={tabData}
                            legends={pieLegends}
                            cx={getCx(inputEl.current)}
                            cy={getCy(inputEl.current)}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

SuccessCard.propTypes = {
    customClass: PropTypes.string,
    tabData: PropTypes.object,
};

export default SuccessCard;
